import api from '../../../services/api.service';
export const types = {
    SET_VALUE: 'deliveriesByAppSetValue',
    SET_CNPJ: 'deliveriesByAppSetCNPJ',
    SET_NAME: 'deliveriesByAppSetName',
    SET_PERIOD: 'deliveriesByAppSetPeriod',
    SET_SHOW_CARRIER: 'deliveriesByAppetSethowCarrier',
    SET_SHOW_PERIOD: 'deliveriesByAppetSethowPeriod',
    LOADER_SHOW: 'loaderShow',
    LOADER_HIDDEN: 'loaderHide'
}

export function setValue(value) {
    return {
        type: types.SET_VALUE,
        value
    }
}


export function setCNPJ(carrier) {
    return {
        type: types.SET_CNPJ,
        carrier,
    }
}

export function setName(name) {
    return {
        type: types.SET_NAME,
        name,
    }
}

export function setPeriod(period) {
    return {
        type: types.SET_PERIOD,
        period,
    }
}

export function setShowCarrier(showCarrier) {
    return {
        type: types.SET_SHOW_CARRIER,
        showCarrier,
    }
}

export function setShowPeriod(showPeriod) {
    return {
        type: types.SET_SHOW_PERIOD,
        showPeriod,
    }
}

export function loaderShow() {
    return {
        type: types.LOADER_SHOW,
        async: true,
    }
}

export function loaderHide() {
    return {
        type: types.LOADER_HIDDEN,
        async: false,
    }
}

export function load() {
    return (dispatch, getState) => {
        const state = getState().crudDeliveriesByApp.deliveriesByApp;
        const filter = {
            carrierDocument: state.filters.carrier.documentNumber || "",
            period: state.filters.period.period || "CURRENT_MONTH"
        }
        // console.log("filter=", filter)
        const URL = `/api/v1/lognex/reports/indicators/deliveries-by-app`;

        dispatch(loaderShow())
        api.post(URL, filter)
            .then(({ data }) => { 

                const {
                    countCargasPlanejadas = 0,
                    countCargasTransito = 0,
                    countCargasRealizadas = 0,
                    countOcorrencias = 0
                } = data.data;

                dispatch(setValue({ countCargasPlanejadas,countCargasTransito, countCargasRealizadas, countOcorrencias }))
                dispatch(loaderHide())
            })
            .catch((error) => {
                const { countCargasPlanejadas = 0, countCargasTransito = 0, countCargasRealizadas = 0, countOcorrencias = 0 } = {};
                dispatch(setValue({ countCargasPlanejadas, countCargasTransito, countCargasRealizadas, countOcorrencias }))
                console.log(error)
                dispatch(loaderHide())
            })
    }
}

